import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
// import Alert from "react-bootstrap/Alert";
import "../../../styles/open-pages/open-pages.css";
import "../../../styles/pt/pt-trials.css";
import "../../../styles/open-pages/import-members.css";
import AllImportMembers from "./AllImportMembers";
import { fetchAllSubscriptionData } from "../../../redux/reducers/apiSlice";
import ImportMemForm from "./ImportMemForm";
import WelcomeUser from "../user/WelcomeUser";
import HelmetWrapper from "../../../HelmetWrapper";
import Notifications from "../../push-notifications/Notifications";
import CommonStructured from "../../common-components/CommonStructured";
// import { objectToQueryString } from "../../common-data/Conversions";
import CmnFilters from "../../lead-management/common/CmnFilters";
import { fetchImportMembersPendingApprovalData } from "../../../redux/payment-reducerss/paymentSlice";

const ImportMembers = ({
  decryptedText,
  // isNotificationDenied,
  isIOS,
  onClickBackBtn,
  isCustom,
}) => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.api);

  const isAdmin = decryptedText?.account_type === "admin";
  const isGym = decryptedText?.account_type === "gym";
  const isClusterManager = decryptedText?.account_type === "cluster_manager";

  // Check if user is a manager role (cluster_manager, fitness_manager, sales_manager, club_manager)
  const isManagerRole = ["cluster_manager", "fitness_manager", "sales_manager", "club_manager"].includes(decryptedText?.account_type);

  const [selectedTab, setSelectedTab] = useState(0);
  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? decryptedText?.name : decryptedText?.gym_name || "",
          value:
            decryptedText?.gym_id ||
            decryptedText?.user_id ||
            decryptedText?.uid ||
            "",
        }
      : "",
    selectedApprovalManager: "",
    selAddedby:
      !isAdmin && !isManagerRole
        ? {
            label: decryptedText?.name || "",
            value: decryptedText?.uid || decryptedText?.user_id || "",
          }
        : "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    trx_id: "import_member",
    gym_id: allFilters.selectedGym?.value || "",
    aprv_rej_by:
      selectedTab === 1 ? "" : allFilters.selectedApprovalManager?.value || "",
    requested_by: allFilters.selAddedby?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  // const [sendableQPs, setSendableQPs] = useState("&trx_id=import_member");
  const [modals, setModal] = useState(false);

  const handleTabSelect = (index) => {
    setSelectedTab(index);
    setIsPage(0);
    setPageLimit(10);
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getPendingImportMembers(filters) {
    const sendableFilters = {
      ...filters,
      page: isPage + 1,
      limit: pageLimit || 10,
      approval_status: selectedTab === 1 ? 0 : selectedTab === 2 ? 1 : 2,
    };

    dispatch(
      fetchImportMembersPendingApprovalData({
        filters: sendableFilters,
        token: decryptedText?.token,
      })
    );
  }

  function getApprovedImportMembers(filters) {
    dispatch(
      fetchAllSubscriptionData({
        filters: filters,
        token: decryptedText?.token,
      })
    );
  }

  function getAllImportMembers(filters) {
    if (!isAdmin && filters) {
      if (selectedTab === 0) {
        getApprovedImportMembers(filters);
      } else {
        getPendingImportMembers(filters);
      }
    } else if (isAdmin) {
      if (selectedTab === 0) {
        getApprovedImportMembers(filters);
      } else {
        getPendingImportMembers(filters);
      }
    }
  }

  useEffect(() => {
    getAllImportMembers(filters);
  }, [filters, isPage, pageLimit, selectedTab]);

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym: !isAdmin && !isManagerRole
        ? {
            label: isGym ? decryptedText?.name : decryptedText?.gym_name || "",
            value:
              decryptedText?.gym_id ||
              decryptedText?.user_id ||
              decryptedText?.uid ||
              "",
          }
        : "",
    }));
  }, [decryptedText?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      gym_id: allFilters.selectedGym?.value || "",
      aprv_rej_by:
        selectedTab === 1
          ? ""
          : allFilters.selectedApprovalManager?.value || "",
      requested_by: allFilters.selAddedby?.value || "",
    }));
  }, [
    allFilters.selectedGym,
    allFilters.selectedApprovalManager,
    allFilters.selAddedby,
    selectedTab,
  ]);

  // useEffect(() => {
  //   const { aprv_rej_by, requested_by, ...rest } = filters;
  //   const stringify = "&" + objectToQueryString(rest);
  //   setSendableQPs(stringify);
  // }, [filters.gym_id, filters.trx_id]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Import Members">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        {decryptedText && isCustom && !isIOS() && (
          <Notifications authData={decryptedText} />
        )}

        <Modal
          isOpen={modals}
          onRequestClose={() => {
            setModal(false);
          }}
          contentLabel="Import Member Modal"
          ariaHideApp={false}
        >
          <ImportMemForm
            setModal={setModal}
            decryptedText={decryptedText}
            callFunction={() => {
              getAllImportMembers(filters);
            }}
          />
        </Modal>

        {/* {isCustom && (
          <Row>
            <Col>
              <BackBtn onClickBtn={(e) => onClickBackBtn(e)} />
            </Col>
          </Row>
        )} */}

        {isCustom && (
          <Row>
            <Col>
              <WelcomeUser userName={decryptedText?.name} />
              {/* {isNotificationDenied === "denied" && (
                <Alert variant={"danger"} className="mt30">
                  Notification permission is denied. Unable to display desktop
                  notifications.
                </Alert>
              )} */}
            </Col>
          </Row>
        )}

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Import Members"}
              createBtnTxt={"+ Import Member"}
              onClickCreateBtn={() => setModal(true)}
              isReload={() => getAllImportMembers(filters)}
              onClickBackBtn={isCustom ? (e) => onClickBackBtn(e) : null}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from={"import-members"}
              userInfoData={decryptedText}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              isLoading={loading}
              selectedTab={selectedTab}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <AllImportMembers
              userInfoData={decryptedText}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              callFunction={() => {
                getAllImportMembers(filters);
                setSelectedTab(0);
              }}
              handleTabSelect={handleTabSelect}
              selectedTab={selectedTab}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default ImportMembers;
